export type RemarkFilter = 'all' | 'open' | 'closed' | 's' | 'e' | 'archived';

interface Props {
  active: RemarkFilter;
  onChange: (f: RemarkFilter) => void;
  counts: { all: number; open: number; closed: number; s: number; e: number; archived: number };
  /** Показывать чип «Показать архив». В UI ГИПа/эксперта чип скрыт. */
  showArchiveChip?: boolean;
  /** 11.4: у заказчика фильтры «Дефекты решения»/«Пробелы комплектности» всегда
   *  0 (они считают defect_type замечаний, а не находки движка) — скрываем. */
  hideDefectFilters?: boolean;
}

const ITEMS: { id: RemarkFilter; label: string; key: keyof Props['counts'] }[] = [
  { id: 'all',    label: 'Все',            key: 'all' },
  { id: 'open',   label: 'Открытые',       key: 'open' },
  { id: 'closed', label: 'Закрытые',       key: 'closed' },
  { id: 's',      label: 'Дефекты решения', key: 's' },
  { id: 'e',      label: 'Пробелы комплектности', key: 'e' },
];

export function SubFilterPills({ active, onChange, counts, showArchiveChip = true, hideDefectFilters = false }: Props) {
  const items = hideDefectFilters ? ITEMS.filter((it) => it.id !== 's' && it.id !== 'e') : ITEMS;
  return (
    <div className="flex items-center" style={{ gap: 8, flexWrap: 'wrap' }}>
      {items.map((it) => {
        const isActive = active === it.id;
        return (
          <button
            key={it.id}
            type="button"
            onClick={() => onChange(it.id)}
            className="rounded-pill transition-colors"
            style={{
              padding: '6px 14px',
              fontWeight: isActive ? 600 : 500,
              fontSize: 13,
              background: isActive ? '#0A1628' : '#FFFFFF',
              color: isActive ? '#FFFFFF' : '#6B7280',
              border: isActive ? '1px solid #0A1628' : '1px solid #E5E7EB',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => { if (!isActive) { e.currentTarget.style.borderColor = 'rgba(10,22,40,.2)'; e.currentTarget.style.color = '#0A1628'; } }}
            onMouseLeave={(e) => { if (!isActive) { e.currentTarget.style.borderColor = '#E5E7EB'; e.currentTarget.style.color = '#6B7280'; } }}
          >
            {it.label} <span className="tabular">({counts[it.key]})</span>
          </button>
        );
      })}
      {showArchiveChip && (
        <button
          type="button"
          onClick={() => onChange(active === 'archived' ? 'all' : 'archived')}
          className="rounded-pill transition-colors"
          style={{
            padding: '6px 14px',
            fontWeight: active === 'archived' ? 600 : 500,
            fontSize: 13,
            background: active === 'archived' ? '#0A1628' : 'transparent',
            color: active === 'archived' ? '#FFFFFF' : '#6B7280',
            border: '1px dashed ' + (active === 'archived' ? '#0A1628' : '#E5E7EB'),
            cursor: 'pointer',
          }}
          title="Показывает только архивные замечания. Архивирование — в меню карточки."
        >
          Показать архив <span className="tabular">({counts.archived})</span>
        </button>
      )}
    </div>
  );
}
